require('./location.less');
import "./maintainReturnLocations.js";



// WEBPACK FOOTER //
// ./src/pages/retailer/maintainLocation/index.js